"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var useTableData_1 = require("./useTableData");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var FinishedRewards = function (_a) {
    var lotteryId = _a.lotteryId;
    var data = (0, swr_hooks_1.useLotteryRewards)({ lotteryId: lotteryId }).data;
    var tableData = (0, useTableData_1.useTableData)(data || []);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tableContainer, " ").concat(styles_module_scss_1.default.prizes) },
        react_1.default.createElement(ui_components_1.DataTable, { data: tableData, lazy: false })));
};
exports.default = FinishedRewards;
